import {pauseSvg as Icon__small__pauseSvg} from '../Icon__small/Icon__small--pause.js';
import {pauseSvg as Icon__xsmall__pauseSvg} from '../Icon__xsmall/Icon__xsmall--pause.js';

export var pause = {
  name: 'pause',
  category: 'icon',
  colorable: true,
  svg: Icon__small__pauseSvg,
  alt: {
    Icon__small: Icon__small__pauseSvg,
    Icon__xsmall: Icon__xsmall__pauseSvg,
  },
  combined: ['Icon__small', 'Icon__xsmall'],
};
